import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommIFStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';

@Component({
    selector: 'app-comms-list-status-indicator',
    templateUrl: './comms-list-status-indicator.component.html',
    styleUrls: ['./comms-list-status-indicator.component.scss'],
    standalone: false,
})
export class CommsListStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() index: number;
    @Input() commIF: CommIFStatus;
    @Output() onSelectCommIf: EventEmitter<CommIFStatus> = new EventEmitter<CommIFStatus>();

    constructor(private systemStatusService: SystemStatusService) {}

    hasAlarms(): boolean {
        if (!this.isReceivingData) return false;
        return this.systemStatusService.getAlarmCounts(this.commIF) > 0;
    }

    selectCommIF() {
        this.onSelectCommIf.emit(this.commIF);
    }
}
